import { selectLandingAccessState } from 'legacy/lut/selectors/app'
import { createSelector } from 'reselect'

export const selectWelcomeFlowWizardShouldAutoOpen = createSelector(
  [selectLandingAccessState],
  ({ isWelcomeFlowEligible, isWelcomeFlowShown }) => {
    // if welcomeFlow is eligble and user didn't fulfilled it, this is criteria to show it
    if (isWelcomeFlowEligible && !isWelcomeFlowShown) {
      return true
    }

    return false
  }
)
